// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-title {
  position: absolute;
  font-size: 2em;
  font-weight: 300;
  max-width: 10em;
  text-transform: uppercase;
}

.contact-us-image-and-offices {
  margin-top: 2.2em;
  margin-left: 4em;
}

.contact-us-image-container {
  top: 5em;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
  width: 60%;
  object-fit: contain;
}

.contact-us-image {
  width: 100%;
  object-fit: contain;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}

.contact-us-offices-container {
  margin-top: 16em;
  display: flex;
  gap: 3em;
  width: 100%;
  justify-content: space-around;
  font-weight: 100;
}

.contact-us-office-title {
  font-size: 1em;
  font-weight: 300;
  text-transform: uppercase;
  color: #fff;
}
.contact-us-image-container>.pos1 {
  position: absolute;
  top: 27%;
  left: 20%;
  z-index: 50;
}
.contact-us-image-container>.pos3 {
  position: absolute;
  top: 36%;
  left: 23%;
  z-index: 50;
}
.contact-us-image-container>.pos2 {
  position: absolute;
  top: 20%;
  left: 55%;
  z-index: 50;
}

.contact-us-feedback-container {
  display: flex;
  width: 100%;
  justify-content: space-around;
  gap: 2em;
}

.contact-us-feedback-image {
  width: 50%;
  height: 35em;
  object-fit: cover;
  padding: 0 2em;
  opacity: 0.75;
}

.contact-us-feedback-text-container {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
}

.contact-us-feedback-text-container h2 {
  font-size: 1.7em;
  font-weight: 300;
  text-transform: capitalize;
}

.contact-us-feedback-text-container p {
  font-size: 1em;
  font-weight: 100;
  line-height: 1.5em;
}

.contact-us-feedback-table {
  display: flex;
  gap: 2em;
  justify-content: space-around;
  flex-wrap: wrap;
}

.contact-us-feedback-item {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 45%;
  padding: 0;
  padding-top: 1em;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  margin: 0;
}

.contact-us-feedback-item h3 {
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  font-weight: 300;
}

.contact-us-feedback-item p {
  font-size: 1em;
  font-weight: 100;
  line-height: 1.5em;
  margin: 0;
  padding: 0;
}

.contact-us-asked-questions {
  display: flex;
  gap: 2em;
}

.contact-us-asked-questions-title-container {
  width: 50%;
}

.contact-us-asked-questions-title-container h2 {
  font-size: 1.7em;
  font-weight: 300;
  text-transform: capitalize;
}

.contact-us-asked-questions-title-container p {
  font-size: 1em;
  font-weight: 100;
  line-height: 1.5em;
}

.contact-us-asked-questions-title-container a {
  color: #fff;
}

.contact-us-asked-questions-table {
  width: 50%;
  list-style: none;
}

.contact-us-asked-questions-item {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  margin-bottom: 2em;
}

.contact-us-asked-questions-item h3 {
  font-size: 1.2em;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

.contact-us-asked-questions-item p {
  font-size: .8em;
  font-weight: 100;
  line-height: 1.5em;
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 768px) {
  .contact-us-image-container {
    top: 10em;
    width: 100%;
  }

  .contact-us-feedback-container {
    flex-direction: column;
  }

  .contact-us-feedback-image {
    width: 100%;
  }

  .contact-us-feedback-text-container {
    width: 100%;
  }


  .contact-us-feedback-image {
    width: 100%;
    object-fit: cover;
    padding: 0;
  }

  
  .contact-us-image-and-offices {
    margin-top: 2.2em;
    margin-left: 0;

    width: 100%;
  }

  .contact-us-offices-container {
    color: #fff;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 0;
    margin-top: 10em;
  }

  .contact-us-carrousel {
    width: 100%;
    display: flex;
    padding-top: 0;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .contact-us-office {
    width: 100%;
    padding: .8em 1.2em;
    margin: 0 auto;
    border: 1px solid #bdbfec;
  }

  .contact-us-feedback-table {
    width: 100%;
    justify-content: space-between;
  }
  
  .contact-us-feedback-item {
    width: 40%;
  }

  .contact-us-asked-questions {
    flex-direction: column;
  }

  .contact-us-asked-questions-title-container {
    width: 100%;
  }

  .contact-us-asked-questions-table {
    width: 100%;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/contact-us.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2FAA2F;AAC7F;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,8CAA8C;EAC9C,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,WAAW;IACX,iBAAiB;IACjB,UAAU;EACZ;;;EAGA;IACE,iBAAiB;IACjB,cAAc;;IAEd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,4BAA4B;IAC5B,2BAA2B;;IAE3B,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".contact-us-title {\n  position: absolute;\n  font-size: 2em;\n  font-weight: 300;\n  max-width: 10em;\n  text-transform: uppercase;\n}\n\n.contact-us-image-and-offices {\n  margin-top: 2.2em;\n  margin-left: 4em;\n}\n\n.contact-us-image-container {\n  top: 5em;\n  left: 50%;\n  transform: translate(-50%);\n  position: absolute;\n  width: 60%;\n  object-fit: contain;\n}\n\n.contact-us-image {\n  width: 100%;\n  object-fit: contain;\n  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));\n}\n\n.contact-us-offices-container {\n  margin-top: 16em;\n  display: flex;\n  gap: 3em;\n  width: 100%;\n  justify-content: space-around;\n  font-weight: 100;\n}\n\n.contact-us-office-title {\n  font-size: 1em;\n  font-weight: 300;\n  text-transform: uppercase;\n  color: #fff;\n}\n.contact-us-image-container>.pos1 {\n  position: absolute;\n  top: 27%;\n  left: 20%;\n  z-index: 50;\n}\n.contact-us-image-container>.pos3 {\n  position: absolute;\n  top: 36%;\n  left: 23%;\n  z-index: 50;\n}\n.contact-us-image-container>.pos2 {\n  position: absolute;\n  top: 20%;\n  left: 55%;\n  z-index: 50;\n}\n\n.contact-us-feedback-container {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  gap: 2em;\n}\n\n.contact-us-feedback-image {\n  width: 50%;\n  height: 35em;\n  object-fit: cover;\n  padding: 0 2em;\n  opacity: 0.75;\n}\n\n.contact-us-feedback-text-container {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n}\n\n.contact-us-feedback-text-container h2 {\n  font-size: 1.7em;\n  font-weight: 300;\n  text-transform: capitalize;\n}\n\n.contact-us-feedback-text-container p {\n  font-size: 1em;\n  font-weight: 100;\n  line-height: 1.5em;\n}\n\n.contact-us-feedback-table {\n  display: flex;\n  gap: 2em;\n  justify-content: space-around;\n  flex-wrap: wrap;\n}\n\n.contact-us-feedback-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 45%;\n  padding: 0;\n  padding-top: 1em;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  margin: 0;\n}\n\n.contact-us-feedback-item h3 {\n  margin: 0;\n  padding: 0;\n  font-size: 1.2em;\n  font-weight: 300;\n}\n\n.contact-us-feedback-item p {\n  font-size: 1em;\n  font-weight: 100;\n  line-height: 1.5em;\n  margin: 0;\n  padding: 0;\n}\n\n.contact-us-asked-questions {\n  display: flex;\n  gap: 2em;\n}\n\n.contact-us-asked-questions-title-container {\n  width: 50%;\n}\n\n.contact-us-asked-questions-title-container h2 {\n  font-size: 1.7em;\n  font-weight: 300;\n  text-transform: capitalize;\n}\n\n.contact-us-asked-questions-title-container p {\n  font-size: 1em;\n  font-weight: 100;\n  line-height: 1.5em;\n}\n\n.contact-us-asked-questions-title-container a {\n  color: #fff;\n}\n\n.contact-us-asked-questions-table {\n  width: 50%;\n  list-style: none;\n}\n\n.contact-us-asked-questions-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  margin: 0;\n  margin-bottom: 2em;\n}\n\n.contact-us-asked-questions-item h3 {\n  font-size: 1.2em;\n  font-weight: 300;\n  margin: 0;\n  padding: 0;\n}\n\n.contact-us-asked-questions-item p {\n  font-size: .8em;\n  font-weight: 100;\n  line-height: 1.5em;\n  margin: 0;\n  padding: 0;\n}\n\n@media screen and (max-width: 768px) {\n  .contact-us-image-container {\n    top: 10em;\n    width: 100%;\n  }\n\n  .contact-us-feedback-container {\n    flex-direction: column;\n  }\n\n  .contact-us-feedback-image {\n    width: 100%;\n  }\n\n  .contact-us-feedback-text-container {\n    width: 100%;\n  }\n\n\n  .contact-us-feedback-image {\n    width: 100%;\n    object-fit: cover;\n    padding: 0;\n  }\n\n  \n  .contact-us-image-and-offices {\n    margin-top: 2.2em;\n    margin-left: 0;\n\n    width: 100%;\n  }\n\n  .contact-us-offices-container {\n    color: #fff;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0;\n    margin-top: 10em;\n  }\n\n  .contact-us-carrousel {\n    width: 100%;\n    display: flex;\n    padding-top: 0;\n    padding-bottom: 0 !important;\n    margin-bottom: 0 !important;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n  }\n\n  .contact-us-office {\n    width: 100%;\n    padding: .8em 1.2em;\n    margin: 0 auto;\n    border: 1px solid #bdbfec;\n  }\n\n  .contact-us-feedback-table {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .contact-us-feedback-item {\n    width: 40%;\n  }\n\n  .contact-us-asked-questions {\n    flex-direction: column;\n  }\n\n  .contact-us-asked-questions-title-container {\n    width: 100%;\n  }\n\n  .contact-us-asked-questions-table {\n    width: 100%;\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
